// extracted by mini-css-extract-plugin
module.exports = {"product":"TopProduct_product__YyZ9m","name":"TopProduct_name__I9p6q","price":"TopProduct_price__3rqvp"};